/**
 * What the navigation calls a document status.
 *
 * The navigation and the status chip named the same selection differently:
 * "Entwürfe" in the navigation against "Status Erfasst" on the chip,
 * "Abgeschlossen" against "Status Beendet" (#2209, O-6). The wording of the
 * status itself — the pill in the list, the one in the document header — is a
 * separate matter and stays as it is; this is only what the navigation offers
 * as a way in, so the chip that results from clicking it says the same word.
 *
 * Shared so the two cannot drift apart again: the navigation builds its links
 * from this map, and the chip reads back from it.
 */
export const PALO_STATUS_NAV_LABEL: Record<string, string> = {
    STATUS_CREATED: 'Entwürfe',
    STATUS_ONGOING: 'In Arbeit',
    // Lies with the member, not with POOLALPIN (R-171).
    STATUS_CART_PENDING: 'Freigabe beim Mitglied',
    STATUS_COMPLETED: 'Abgeschlossen',
    // STATUS_COMPLETED_WITH_TRANSITION is deliberately absent: an order calls
    // it "Abgerechnet", an inquiry "Abgeschlossen". One word cannot serve both,
    // so it keeps the status wording.
    STATUS_CANCELED: 'Storniert',
};

/** The navigation's word for a status, or nothing where it offers none. */
export const paloStatusNavLabel = (status: string): string | undefined => PALO_STATUS_NAV_LABEL[status];
